import { render, staticRenderFns } from "./IssIseServices.vue?vue&type=template&id=0b68c49f&"
import script from "./IssIseServices.vue?vue&type=script&lang=js&"
export * from "./IssIseServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports